import * as React from "react";

export const HeartIconFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 25 24" {...props}>
    <g fillRule="nonzero">
      <path d="M21.872 3.211a6.98 6.98 0 00-9.872 0 6.982 6.982 0 00-9.872 9.872l9.05 9.05c.453.454 1.19.454 1.644 0l9.05-9.05a6.98 6.98 0 000-9.872" />
    </g>
  </svg>
);
